<template>
    <section class="header" :class="{ 'header_menu-open' : menuIsOpen }">
        <router-link :to="{name: this.curLocaleName + 'home', params: { locale: this.curLocaleAlias }}" class="main_logo outer_pages" v-on:click.native="killClass">
            <span class="icon-logo"></span>
        </router-link>
        <router-link to="/">
            <span class="main_logo homePage_logo" @click="toHomeVidget">
                <span class="icon-logo"></span>
            </span>
        </router-link>
        <router-link :to="{name: this.curLocaleName + 'home', params: { locale: this.curLocaleAlias }}" class="menu-trigger backBtn">{{ $t('header.back') }}</router-link>
        <div class="menu-trigger desk" @click="openCloseMenu">{{ $t('header.menuTitle') }}</div>
        <div class="menu-trigger mob" @click="openCloseMenu">{{ $t('header.menuTitle_mob') }}</div>
        <div class="header_menu_wrap">
            <div class="menu__column homePage_logo" id="siteNav">
                <div class="menu__item menu__item_page large_links" data-menuanchor="home" @click="openCloseMenu">
                    <a href="/" class="active menu__link menu__link_page hidden_link"><span class="topHide"><span>{{ $t('header.home') }}</span></span></a>
                </div>
                <div class="menu__item" data-menuanchor="approach" @click="openCloseMenu">
                    <a href="about" class="menu__link"><span class="topHide"><span>{{ $t('header.approach') }}</span></span></a>
                </div>
                <div class="menu__item" data-menuanchor="scale" @click="openCloseMenu">
                    <a href="brand_mission_strategy" class="menu__link"><span class="topHide"><span>{{ $t('header.scale') }}</span></span></a>
                </div>
                <div class="menu__item" data-menuanchor="marketing_support" @click="openCloseMenu">
                    <a href="#brands" class="menu__link"><span class="topHide"><span>{{ $t('header.marketingSupport') }}</span></span></a>
                </div>
                <div class="menu__item" data-menuanchor="brands" @click="openCloseMenu">
                    <a href="#brands/all_brands" class="menu__link"><span class="topHide"><span>{{ $t('header.brands') }}</span></span></a>
                </div>
                <div class="menu__item" data-menuanchor="customer_service" @click="openCloseMenu">
                    <a href="#customer_service" class="menu__link"><span class="topHide"><span>{{ $t('header.customerService') }}</span></span></a>
                </div>
                <div class="menu__item" data-menuanchor="software_integration" @click="openCloseMenu">
                    <a href="https://b2b.smartgroup.ua" class="menu__link"><span class="topHide"><span>{{ $t('header.softwareIntegration') }}</span></span></a>
                </div>
            </div>
            <div class="menu__column outer_pages">
                <div class="menu__item menu__item_page large_links">
                    <router-link :to="{name: this.curLocaleName + 'home#home', params: { locale: this.curLocaleAlias }}" class="active menu__link menu__link_page hidden_link"><span class="topHide"><span>{{ $t('header.home') }}</span></span></router-link>
                </div>
                <div class="menu__item">
                    <router-link :to="{name: this.curLocaleName + 'about', params: { locale: this.curLocaleAlias }}" class="menu__link"><span class="topHide"><span>{{ $t('header.approach') }}</span></span></router-link>
                </div>
                <div class="menu__item">
                    <router-link :to="{name: this.curLocaleName + 'brand_mission_strategy', params: { locale: this.curLocaleAlias }}" class="menu__link"><span class="topHide"><span>{{ $t('header.scale') }}</span></span></router-link>
                </div>
                <div class="menu__item">
                    <router-link :to="{name: this.curLocaleName + 'home#brands', params: { locale: this.curLocaleAlias }}" class="menu__link"><span class="topHide"><span>{{ $t('header.marketingSupport') }}</span></span></router-link>
                </div>
                <div class="menu__item">
                    <a href="/#brands/all_brands" class="menu__link"><span class="topHide"><span>{{ $t('header.brands') }}</span></span></a>
                </div>
                <div class="menu__item">
                    <router-link :to="{name: this.curLocaleName + 'home#customer_service', params: { locale: this.curLocaleAlias }}" class="menu__link"><span class="topHide"><span>{{ $t('header.customerService') }}</span></span></router-link>
                </div>
                <div class="menu__item">
                    <a href="https://b2b.smartgroup.ua" class="menu__link"><span class="topHide"><span>{{ $t('header.softwareIntegration') }}</span></span></a>
                </div>
            </div>
            <div class="menu__column">
                <div class="menu__item menu__item_page large_links">
                    <a href="https://b2b.smartgroup.ua" class="menu__link menu__link_page"><span>{{ $t('header.partners') }}</span></a>
                </div>
            </div>
            <div class="menu__column">
                <div class="menu__item menu__item_page large_links">
                    <a href="#scale" class="menu__link menu__link_page"><span>{{ $t('header.retail') }}</span></a>
                </div>
            </div>
            <div class="menu__column">
                <div class="menu__item menu__item_page large_links">
                    <a href="https://service.smartgroup.ua" class="menu__link menu__link_page"><span>{{ $t('header.service') }}</span></a>
                </div>
            </div>
            <div class="menu__column">
                <div class="menu__item menu__item_page large_links">
                    <router-link :to="{name: this.curLocaleName + 'contact', params: { locale: this.curLocaleAlias }}" class="menu__link menu__link_page"><span>{{ $t('header.contacts') }}</span></router-link>
                </div>
            </div>
        </div>
        <!-- <a href="/" class="menu__link menu__link_page auth_link">{{ $t('header.login') }}</a> -->
        <div class="languages">
            <span @click="switchLang('en')" class="languages__item" v-bind:class=" this.$i18n.locale == 'en' ? 'languages__item_active' : '' ">En</span>
            <span @click="switchLang('ru')" class="languages__item" v-bind:class=" this.$i18n.locale == 'ru' ? 'languages__item_active' : '' ">Рус</span>
            <span @click="switchLang('ua')" class="languages__item" v-bind:class=" this.$i18n.locale == 'ua' ? 'languages__item_active' : '' ">Укр</span>
        </div>
    </section>
</template>

<script>
    import i18n from '../lang/lang'
    import conf from '../../public/site_config.json'
    import router from '../router'

    export default {
        name: 'app',
        data: function () {
            return {
                menuIsOpen: false,
                isBackVisible: 'hiddenBack',
                //mediakit: $t('footer.mediakit_link'),
                params: {
                    state: false
                }
            }
        },
        methods: {
            openCloseMenu: function() {
                this.menuIsOpen = !this.menuIsOpen
                
                if(this.menuIsOpen) 
                    document.body.classList.add('menuOpen');
                else 
                    document.body.classList.remove('menuOpen');
            },
            toHomeVidget() {
                $.fn.fullpage.moveTo('home', true);
            },
            killClass: function() {
                $('body').removeClass('pPage');
            }
        },
        mounted() {
            
        },
        beforeDestroy() {
            this.menuIsOpen = false
            document.body.classList.remove('menuOpen');
        }
    }
</script>

<style scoped lang="stylus">
    .hidden_link
        visibility visible
        // color #C6C8CC
        
        @media (min-width 1024px)
            visibility hidden
    
    .header
        width calc(100% - 40px)
        padding 25px 20px 0
        height 55px
        position fixed
        top 0
        left 0
        display flex
        justify-content space-between
        z-index 100
        -webkit-transition all .5s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .5s cubic-bezier(.25,.01,.25,1)
        transition all .5s cubic-bezier(.25,.01,.25,1)
        
        &:before
            width 100%
            height 0
            position absolute
            top 0
            left 0
            background #fff
            content ''
            -webkit-transition all .5s cubic-bezier(.25,.01,.25,1)
            -moz-transition all .5s cubic-bezier(.25,.01,.25,1)
            transition all .5s cubic-bezier(.25,.01,.25,1)
        
        @media (min-width 700px)
            width calc(100% - 70px)
            padding 35px 35px 0
        
        @media (min-width 1024px)
            width calc(100% - 160px)
            padding 40px 80px 0
            
        @media (min-width 1600px)
            width calc(100% - 200px)
            padding 40px 100px
         
    body.menuOpen .header
        &:before
            height 320px
            
            @media (max-width 1023px)
                height 100%

    body.hideTopBar
        .header, .menu-trigger
            top -100px

    body.hideHeader .header
        width 70%
   
    .header_menu-open
        height 100%
        
        @media (min-width 1024px)
            height 280px
           
    .header_black
        color #fff

    .main_logo
        color #fff
        text-decoration none
        font-size 26px
        position relative
        z-index 105
        height 15px
        overflow hidden
        cursor pointer
        -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
        -moz-transition .3s cubic-bezier(.25,.01,.25,1)
        transition .3s cubic-bezier(.25,.01,.25,1)
        
        &:hover
            color #fff
            opacity .5
            
    body.processPage .main_logo
        @media (max-width 699px)
            left calc(50% - 13px)

    body.lightBack .main_logo
        color #000
        
        &:hover
            color #000
            opacity .7

    .icon-logo
        &:before
            position relative
            top -9px
    
    .languages
        position absolute
        right 80px
        top 39px
        display none
        height 15px
        z-index 105
        -webkit-transition all .3s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .3s cubic-bezier(.25,.01,.25,1)
        transition all .3s cubic-bezier(.25,.01,.25,1)

        @media (min-width 1024px)
            display flex
            
        @media (min-width 1600px)
            right 100px
    
    body.hideHeader .languages
        top -100px
        opacity 0

    body.menuOpen .languages
        @media (max-width 1023px)
            display block
            top 21px
            right calc(50% - 55px)

    .languages__item
        margin 0 12px
        font-weight 600
        color #808080
        cursor pointer
        -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
        -moz-transition .3s cubic-bezier(.25,.01,.25,1)
        transition .3s cubic-bezier(.25,.01,.25,1)
        
        &:last-child
            margin-right 0
            
        &:hover
            color #fff
       
    body.lightBack .languages__item
        &:hover
            color #000

    .languages__item_active
        position relative
        color #fff

        &:before
            content ''
            position absolute
            left 50%
            top -39px
            transform translateX(-50%)
            width 40px
            height 2px
            background #fff
            cursor default

    body.lightBack .languages__item_active
        color #000
        
        &:before
            background #000
    
    body.menuOpen .languages__item_active
        &:before
            @media (max-width 1023px)
                top -24px
            
    .menu__column
        padding-right 110px
        
        @media (min-width 1600px)
            padding-right 146px
        
        @media (max-width 1400px)
            padding-right 55px

        @media (max-width 1200px)
            padding-right 15px

    .header_menu_wrap
        box-sizing border-box
        position absolute
        left 20px
        top 50px
        width calc(100% - 40px)
        height 24px
        overflow auto
        color #808080
        white-space nowrap
        display block
        overflow hidden
        flex-direction row
        justify-content left
        -webkit-transition all .3s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .3s cubic-bezier(.25,.01,.25,1)
        transition all .3s cubic-bezier(.25,.01,.25,1)

        @media (min-width 700px)
            width calc(100% - 70px)
            left 35px
            top 70px
        
        @media (min-width 1024px)
            width calc(100% - 490px)
            left 250px
            top 40px
            display flex

    body.lightBack .header_menu_wrap,
    .header_menu-open .header_menu_wrap
        color #000
        
    .header_menu-open .header_menu_wrap
        height calc(100% - 90px)
        
        @media (min-width 1024px)
            height 270px
        
    .menu__item
        padding 5px 0

        @media (min-width 1024px)
            padding 0 0 12px 0

    .menu__item_page
        padding 32px 0 0

        @media (min-width 1024px)
            padding 0 0 12px 0

    .menu__list
        height 100%
        overflow auto

    .menu__link_page
        font-size 18px
        font-weight bold
        
        @media (min-width 1024px)
            font-size 14px
            
        @media (min-width 1600px)
            font-size 16px

    .menu-trigger
        color #808080
        cursor pointer
        align-items center
        font-weight bold
        z-index 6
        height 15px
        position fixed
        right 20px
        top 25px
        white-space nowrap
        -webkit-transition all .5s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .5s cubic-bezier(.25,.01,.25,1)
        transition all .5s cubic-bezier(.25,.01,.25,1)
        
        @media (min-width 700px)
            top 35px
            right 35px
        
        @media (min-width 1024px)
            width 60px
            top 32px
            right 32px
        
        &:hover
            color #fff
            
            &:after
                border-color #fff transparent transparent transparent

        .header_menu-open &
            right 20px
            
            @media (min-width 700px)
                right 35px
            
            @media (min-width 1024px)
                right 32px

        &:after
            content ''
            width 0
            height 0
            border-style solid
            border-width 3px 3px 0 3px
            border-color #808080 transparent transparent transparent
            margin-left 4px
            -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
            -moz-transition .3s cubic-bezier(.25,.01,.25,1)
            transition .3s cubic-bezier(.25,.01,.25,1)

            .header_menu-open &
                transform rotate(180deg)

            &:after
                border-color #000 transparent transparent transparent

        @media (min-width 1024px)
            right auto
            left 250px
            top 42px

    .menu-trigger.desk {
        @media (max-width: 1023px) {
            display none
        }

        @media (min-width: 1024px) {
            display flex
        }
    }

    .menu-trigger.mob {
        @media (max-width: 1023px) {
            display flex
        }

        @media (min-width: 1024px) {
            display none
        }
    }

    body.lightBack .menu-trigger {
        color #000
    }
    
    body.hideHeader .menu-trigger
        top -100px
        opacity 0
    
    body.hideHeader .header_menu_wrap
        top -100px
        opacity 0

    .menu-trigger.backBtn
        top 22px
        
        @media (max-width 699px)
            right auto
            left 20px
        
        @media (min-width 700px)
            top 35px
        
        @media (min-width 1024px)
            top 38px
        
        &:after
            display none
            
        &:before
            content ''
            width 0
            height 0
            border-style solid
            display inline-block
            border-width 3px 3px 3px 0
            border-color transparent #808080 transparent transparent
            margin-right 4px
            position relative
            top -2px
            
    body.processPage .menu-trigger
        display none
    
    .backBtn
        display none
        
    body.processPage .backBtn
        display block
            
    .header_menu-open .menu-trigger
        color #000
        white-space nowrap
            
        &:hover
            color #000
            
        &:after
            border-color #000 transparent transparent transparent
    
    body.lightBack .menu-trigger
        &:hover
            color #000
            
            &:after
                border-color #000 transparent transparent transparent

    .auth_link 
        color #808080
        position absolute
        top 40px
        right 270px
        display none
        -webkit-transition all .3s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .3s cubic-bezier(.25,.01,.25,1)
        transition all .3s cubic-bezier(.25,.01,.25,1)
    
        &:hover
            color #fff
            
        @media (min-width 1024px)
            display block
            
        @media (min-width 1600px)
            right 350px
    
    body.hideHeader .auth_link
        top -100px
        opacity 0

    body.lightBack .auth_link
        &:hover
            color #000
            
    .large_links
        @media (max-width 1023px)
            padding-top 15px
            
            

    /* open menu animation */
    .topHide
        display block
        overflow hidden

        span
            position relative
            top -70px
            -webkit-transition .4s cubic-bezier(.25,.01,.25,1)
            -moz-transition .4s cubic-bezier(.25,.01,.25,1)
            transition .4s cubic-bezier(.25,.01,.25,1)
            -webkit-transition-delay .3s
            -moz-transition-delay .3s
            transition-delay .3s
    
    body.menuOpen
        .topHide
            span
                top 0
    
            
</style>
